<template>
  <div>
  <main class="w-full" id="narrativeCanvas">
    <!-- CONTENT INJECTION HAPPENS HERE -->
    <div :id="e.Oid + '-container'" v-for="(e, idx) in narrative.elements">
      <div :id="e.Oid + '-trigger'">
        <span class="text-sm uppercase" v-if="debugMode">
          trigger {{ e.Oid }} // {{ e.type }}
        </span>
      </div>
      <narrative-element
        :scale-factor="scaleFactor"
        :element="e"
      ></narrative-element>
    </div>

    <!-- <div style="height:800px"></div> -->
    <!-- <div id="trigger"></div> -->
    <!-- <div id="changer" class="w&#45;24 h&#45;24 bg&#45;red&#45;600 z&#45;1"></div> -->
    <!--   <div style="height:100px"></div> -->
    <!--   <div id="trigger&#45;2"></div> -->
    <!--   <div style="height:800px"></div> -->
  </main>
  </div>
</template>

<script>
// import Component from "../component_location"
import NarrativeElement from "@/components/NarrativeElements/NarrativeElement.vue";

export default {
  components: { NarrativeElement },

  props: { narrative: { type: Object, default: () => {} } },

  data() {
    return {
      debugMode: true,
    };
  },

  watch: {},

  methods: {},

  computed: {
    scaleFactor() {
      if (document.querySelector("#narrativeCanvas")) {
        return (
          document.querySelector("#narrativeCanvas").clientWidth /
          window.innerWidth
        );
      } else {
        return 1;
      }
    },
  },

  mounted() {
    // Tell the outside world that we're fully formed...
    this.$emit("ready");
  },
};
</script>

<style>
.image {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.1;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover !important;
  object-position: 50% 50%;
}
#narrativeCanvas {
  background-color: "#afafaf";
  min-height: 2500px;
}
</style>
